import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

const StyledDesktopNavLink = styled(NavLink)`
  flex: 0 1 auto;
  color: #484848;
  text-decoration: none;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  padding: 6px 24px;
  display: flex;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  word-break: keep-all;
  text-align: center;
  white-space: pre-line;
`;

export default StyledDesktopNavLink;
